import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

export const PROMO_CODE = "PROOZENTYA";
export const PROMO_PERCENT = 10;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const copyPromo = async () => {
  try {
    await navigator.clipboard.writeText(PROMO_CODE);
    toast.success(window.location.pathname.startsWith("/en/") ? `Code ${PROMO_CODE} copied` : `Code ${PROMO_CODE} copié`);
  } catch {
    toast(window.location.pathname.startsWith("/en/") ? `Your code: ${PROMO_CODE}` : `Votre code : ${PROMO_CODE}`);
  }
};

let cache = null;
const fetchPromo = () => (cache ||= axios.get(`${API}/promo/current`).then((r) => r.data).catch(() => ({ active: false })));

const left = (ends) => {
  const ms = new Date(ends) - Date.now();
  if (ms <= 0) return null;
  const h = Math.floor(ms / 3600000), m = Math.floor((ms % 3600000) / 60000);
  return h > 0 ? `${h} h ${String(m).padStart(2, "0")} min` : `${m} min`;
};

export const usePromo = () => {
  const [p, setP] = useState(null);
  const [, tick] = useState(0);
  useEffect(() => { fetchPromo().then(setP); }, []);
  useEffect(() => {
    if (!p?.ends_at) return undefined;
    const id = setInterval(() => tick((n) => n + 1), 30000);
    return () => clearInterval(id);
  }, [p]);
  const remaining = p?.ends_at ? left(p.ends_at) : null;
  const active = !!p?.active && (!p.ends_at || !!remaining);
  return { loaded: !!p, active, remaining };
};
